import { MouseEvent } from 'react';

interface ClearFilterButtonProps {
    active: boolean;
    onClear: () => void;
}

export default function ClearFilterButton({ active, onClear }: Readonly<ClearFilterButtonProps>) {
    if (!active) {
        return null;
    }

    const clearStyle = {
        background: 'none',
        border: 'none',
        color: '#9e9e9e',
        cursor: 'pointer',
        marginLeft: '8px',
        marginBottom: '2px',
        padding: 0,
        fontSize: '16px',
    };

    function handleClick(event: MouseEvent) {
        event.stopPropagation();
        onClear();
    }

    return (
        <button aria-label="Clear filters" style={clearStyle} onClick={handleClick}>
            x
        </button>
    );
}
